import { render, staticRenderFns } from "./RbEmptyState.vue?vue&type=template&id=345dbfd6&"
import script from "./RbEmptyState.vue?vue&type=script&lang=js&"
export * from "./RbEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./RbEmptyState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports